var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoTowerNoBg = function SvgLogoTowerNoBg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0299 0.0111606L9.7035 1.64984H7.35211L7.0257 0.0111606H5.0589L4.73251 1.64984H2.66491L2.3385 0.0111606H0L0.423001 4.33754H11.5731L12 0L10.0299 0.0111606Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.549805 5.17218L0.606805 6.00645L0.824902 8.38288L0.834204 8.49056L0.834506 8.48936L1.2296 12.7998L5.99121 16.9998L5.9996 16.9518L6.00801 16.9998L10.7693 12.7998L11.3921 6.00615L11.4467 5.2135L11.4614 5.17188H0.549805V5.17218ZM2.02791 6.87812H4.9538V14.2608L2.4671 11.9839L2.02791 6.87812ZM7.1336 14.1799V6.87812H9.9713L9.53211 11.9839L7.1336 14.1799Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoTowerNoBg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-tower-no-bg.2dc83a0d.svg";
export { ForwardRef as ReactComponent };